import { Button } from 'components/Button';
import Icon from 'components/Icon/Icon.component';
import LogoutIcon from 'images/icons/logout-icon.svg?react';
import { Translate } from 'react-localize-redux';
import { useLogoutMutation } from 'services/authentication-ms/post-logout';

function LogoutBtn() {
  /*------------------------------hooks------------------------------*/
  const { handleLogout } = useLogoutMutation();

  return (
    <Button
      onClick={handleLogout}
      padding={'0 9px 0 7px'}
      height={'25px'}
      fontSize={'12px'}
      letterSpacing={'0px'}
    >
      <Icon
        viewBox={'0 0 90 90'}
        svgIconComponent={LogoutIcon}
        iconSize={'16px'}
        margin="0 3px 0 0"
      />
      <Translate id="lbl.logout" />
    </Button>
  );
}

export { LogoutBtn };
